import { useState } from "react";
import { useCallback, useEffect, useRef } from "react";

const SCROLL_RESOLUTION = 6000;

function clamp(min, max, num) {
	return Math.min(Math.max(num, min), max);
}

function getSectionNumber(input, numSections) {
	const sectionSize = SCROLL_RESOLUTION / numSections;
	return clamp(0, numSections, Math.ceil(input / sectionSize) - 1);
}

function getProgressBySectionNumber(input, numSections) {
	const sectionSize = SCROLL_RESOLUTION / numSections;

	return sectionSize * (input + 1) - sectionSize / 2;
}

export function useActiveDesktop(rootRef, enabled) {
	const [active, setActive] = useState(-1);
	const progress = useRef(0);

	const handleMouseWheel = useCallback((event) => {
		if (!event.deltaY) return;
		
		const cardsNumber = rootRef.current.childNodes.length;

		progress.current = clamp(
			0,
			SCROLL_RESOLUTION,
			progress.current + event.deltaY,
		);

		setActive(getSectionNumber(progress.current, cardsNumber));
	}, []);

	useEffect(() => {
		if (!enabled) return;

		window.addEventListener("wheel", handleMouseWheel);

		return () => {
			window.removeEventListener("wheel", handleMouseWheel);
		};
	}, [enabled]);

	useEffect(() => {
		if (active === -1) return;

		rootRef.current.scrollTo({
			top: 0,
			left: rootRef.current.childNodes[active].offsetLeft - 100,
			behavior: "smooth",
		});
	}, [active]);

	const setSection = useCallback((index) => {
		const cardsNumber = rootRef.current.childNodes.length;

		progress.current = getProgressBySectionNumber(index, cardsNumber);

		setActive(getSectionNumber(progress.current, cardsNumber));
	}, []);

	return { active, setSection };
}
